import { Skeleton, TableCell, TableRow } from '@mui/material';
import { FC, ReactNode } from 'react';

type Props = {
  height: number;
  isLoading: boolean;
  children: ReactNode;
};

const LoadingTableRows: FC<Props> = ({ height, isLoading, children }) => (
  <>
    {isLoading ? (
      <TableRow sx={{ height }}>
        <TableCell>
          <Skeleton />
        </TableCell>
        <TableCell align="right">
          <Skeleton />
        </TableCell>
      </TableRow>
    ) : (
      <>{children}</>
    )}
  </>
);

export default LoadingTableRows;
